__turbopack_context__.v({
  "buttonSpacer": "_4p80mG_buttonSpacer",
  "pageControls": "_4p80mG_pageControls",
  "paginationButton": "_4p80mG_paginationButton",
});
